<template>
    <section class="palette-items-container">
        <div :class="`palette-${columnType}-items palette-${columnType}-items__text bg-rothcoCream`">
            <div v-for="(column, index) in props.columns" :key="index" class="pti-item pti-item__vertical">
                <h3 class="pti-item__title title-m">{{ column.title }}</h3>
                <p class="pti-item__details paragraph-details">{{ column.body }}</p>
            </div>
        </div>
    </section>
</template>
<script lang="ts" setup>
    import { computed } from "vue";
    let props = defineProps({
        columns: {
            type: Array<Object>,
            default: [],
        },
    });
    let columnType = computed(()=>{
        return props.columns.length > 3 ? 'four' : 'three'
    });
</script>